module.exports = __webpack_public_path__ + "media/images/prizes__prizeFg--1-b8f4e7ed16a8c6fdc583acd0c6215525.png";